import React from 'react'
import ImageLoader from './imageLoader'
import BootstrapImage from 'react-bootstrap/Image'
import { Spinner } from 'react-bootstrap'
import styled from '@emotion/styled'

const ImageError = () => <div>Error</div>
const ImageLoading = () => <Spinner animation="border" variant="secondary" />

const Image = (props) => (
  <ImageLoader {...props}>
    {props.children}
    <ImageError />
    <ImageLoading />
  </ImageLoader>
)
const BackgroundImage = ({ src, style = {}, ...props } = {}) => (
  <div
    style={Object.assign(
      {
        backgroundImage: `url(${src})`,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%',
      },
      style
    )}
    {...props}
  />
)

export const BackgroundImageWithLoader = ({ src, ...props } = {}) => (
  <Image
    src={src}
    wrapperProps={{
      style: {
        width: '100%',
        height: '100%',
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    }}
  >
    <BackgroundImage {...props} />
  </Image>
)

export const ImageWithLoader = ({ src, ...props }) => (
  <Image src={src}>
    <BootstrapImage {...props} />
  </Image>
)

export const ImageBase64 = (props) => {
  let base64Src = 'data:image/jpeg;base64,' + props.ImageBase64Encoded
  return <SImage src={base64Src} alt="" invalid={props.invalid} />
}

//styled
export const SImage = styled('img')`
  label: SImage;
  opacity: ${(props) => (props.invalid ? 0.5 : 1)};
  max-width: 100%;
`
